<template>
  <div class="navigation-header full-width-bleed">
    <div class="navigation-header__container container">
      <div class="navigation-header__search-container" @click="searchClicked">
        <div class="navigation-header__search-icon"></div>
        <div class="navigation-header__search-text">Search</div>
      </div>

      <div class="navigation-header__compare-basket-container" @click="compareBasketClicked">
        <div class="navigation-header__compare-basket-icon"></div>
        <div class="navigation-header__compare-basket-text">Compare {{ comparisonCount }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCarComparisonStore } from '../../foundation/stores/carComparisonStore';
import { useModalStore } from '../../foundation/stores/modalStore';
import { computed } from 'vue';

const comparisonStore = useCarComparisonStore();
const modalStore = useModalStore();

/**
 * Computed properties
 */
const comparisonCount = computed(() => `(${comparisonStore.vehicleIdsInCart.length}/${comparisonStore.maxLimit})`);

/** Methods */
/**
 * Opens the comparison sticky when clicked
 */
function compareBasketClicked() {
  comparisonStore.showCarComparisonFooter = true;
}

/**
 * Open the main modal when clicked
 */
function searchClicked() {
  modalStore.toggleMakeModelModal('');
}
</script>

<style lang="scss" scoped>
.navigation-header {
  height: 60px;
  color: $racq-navy;
  font-family: $firasans-regular-font;
  font-size: 1rem;
  background-color: $racq-car-advisory-pale-blue;

  @media screen and (min-width: #{$breakpoint-md}) {
    height: 80px;
  }
}

.navigation-header__container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  margin: 0 auto;
}

.navigation-header__search-container,
.navigation-header__compare-basket-container {
  display: flex;
  gap: 0.5rem;

  &:hover {
    cursor: pointer;
  }
}

.navigation-header__search-icon,
.navigation-header__compare-basket-icon {
  content: '';
  background-image: url(@/assets/img/magnifying-glass.svg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  width: 1rem;
  height: auto;

  &:not(.navigation-header__search-icon) {
    background-image: url(@/assets/img/compare-basket.svg);
  }
}
</style>
